import React from 'react';

import TableHeader from '../TableHeader/TableHeader';
import Checkbox from '../../Checkbox/Checkbox';
import Icon from '../../Icon/Icon';

import { childrenWithTrigger } from '../helpers/helpers';

function Headers(props) {
  const showExpand = props.toggled.filter(Boolean).length !== childrenWithTrigger(props.defineChildren);

  const toggleLabel = showExpand ? 'expand-all' : 'collapse-all';

  return props.headers.map((header, index) => (
    <React.Fragment key={index}>
      {index === 0 && props.selectable === 'single' && <TableHeader checkbox freeze={header.freeze} />}
      {index === 0 && props.selectable === 'all' && (
        <TableHeader checkbox freeze={header.freeze}>
          <Checkbox
            id={`${props.id}-${index}`}
            value={props.selected.length === props.data.length}
            onChange={props.selectAll}
          />
        </TableHeader>
      )}
      {index === 0 && props.toggleable && (
        <TableHeader toggleable onClick={props.toggleAll} ariaLabel={toggleLabel} freeze={header.freeze}>
          <Icon size="lg" type={toggleLabel} />
        </TableHeader>
      )}
      <TableHeader
        onClick={() => props.toggleActiveHeader(header, index)}
        order={header.order}
        indent={header.indent}
        sortable={header.sortable}
        right={header.right}
        checkbox={header.checkbox}
        colSpan={header.colSpan}
        wrapText={props.wrapHeaders}
        help={header.help}
        freeze={header.freeze}
      >
        {header.label}
      </TableHeader>
    </React.Fragment>
  ));
}

export default Headers;
